// ============================================================
// [NEW-CUSTOM] 无限滚动（方案 A：URL 分页 + 滚动触发）
// 文件名：custom-infinite-scroll.js
// 依赖：#product-grid、.grid__item，与阶段 2 自定义卡片兼容
// ============================================================

// ========== [NEW-CUSTOM] 无限滚动主逻辑 - 开始 ==========
(function () {
  'use strict';

  // ---------- 配置 ----------
  var SCROLL_THRESHOLD = 200;   // 距底部 200px 触发
  var DEBOUNCE_DELAY = 300;     // 防抖 300ms

  // ---------- 状态 ----------
  var grid = null;
  var loadingEl = null;
  var noMoreEl = null;
  var currentPage = 1;
  var totalPages = 1;
  var isLoading = false;
  var allLoaded = false;
  var debounceTimer = null;

  // ---------- 工具：从 URL 读取当前页码 ----------
  function getCurrentPageFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page'), 10);
    return isNaN(page) || page < 1 ? 1 : page;
  }

  // ---------- 工具：拼接下一页 URL（保留现有筛选/排序参数） ----------
  function buildNextPageUrl(nextPage) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    // 强制走 section rendering 接口，只取网格部分
    url.searchParams.set('section_id', getSectionId());
    return url.toString();
  }

  // ---------- 工具：从 grid 上取 section id ----------
  function getSectionId() {
    if (!grid) return '';
    return grid.getAttribute('data-id') || '';
  }

  // ---------- 工具：读取总页数（优先从 DOM 的 data-total-pages 读取） ----------
  function detectTotalPages() {
    // 先找组件上 Liquid 传过来的准确总页数
    var comp = document.querySelector('collection-component[data-total-pages]');
    if (comp) {
      var total = parseInt(comp.getAttribute('data-total-pages'), 10);
      if (!isNaN(total) && total > 0) {
        return total;
      }
    }
    // 兜底：找页面里的分页 DOM
    var pageLinks = document.querySelectorAll('.pagination__item, .pagination a[href*="page="]');
    var maxPage = 1;
    pageLinks.forEach(function (el) {
      var href = el.getAttribute('href') || '';
      var m = href.match(/page=(\d+)/);
      if (m) {
        var n = parseInt(m[1], 10);
        if (n > maxPage) maxPage = n;
      }
    });
    return maxPage;
  }

  // ---------- 加载状态显示/隐藏 ----------
  function showLoading() {
    if (loadingEl) loadingEl.style.display = 'flex';
  }
  function hideLoading() {
    if (loadingEl) loadingEl.style.display = 'none';
  }
  function showNoMore() {
    if (noMoreEl) noMoreEl.style.display = 'block';
  }

  // ---------- 加载下一页 ----------
  function loadNextPage() {
    if (isLoading || allLoaded) return;
    if (currentPage >= totalPages) {
      allLoaded = true;
      showNoMore();
      return;
    }

    isLoading = true;
    showLoading();

    var nextPage = currentPage + 1;
    var url = buildNextPageUrl(nextPage);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('#product-grid > .grid__item');

        if (!newItems.length) {
          allLoaded = true;
          showNoMore();
          return;
        }

        // append 新商品
        newItems.forEach(function (item) {
          // 重置 scroll-trigger 动画状态，避免新加的商品不可见
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          grid.appendChild(item);
        });

        currentPage = nextPage;

        // 如果已经到最后一页，锁定
        if (currentPage >= totalPages) {
          allLoaded = true;
          showNoMore();
        }
      })
      .catch(function (err) {
        // 失败时允许用户再试，不锁定
        console.warn('[NEW-CUSTOM] 无限滚动加载失败：', err);
      })
      .finally(function () {
        isLoading = false;
        hideLoading();
      });
  }

  // ---------- 滚动监听（带防抖） ----------
  function onScroll() {
    if (isLoading || allLoaded) return;

    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var windowHeight = window.innerHeight;
      var docHeight = document.documentElement.scrollHeight;

      if (docHeight - (scrollTop + windowHeight) <= SCROLL_THRESHOLD) {
        loadNextPage();
      }
    }, DEBOUNCE_DELAY);
  }

  // ---------- 初始化 ----------
  function init() {
    grid = document.getElementById('product-grid');
    if (!grid) return;

    loadingEl = document.querySelector('[data-cis-loading]');
    noMoreEl = document.querySelector('[data-cis-no-more]');

    currentPage = getCurrentPageFromUrl();
    
    // 从 Liquid 传过来的 data-total-pages 读取总页数
    totalPages = detectTotalPages();

    // 如果当前页已经是最后一页，直接显示 No more items
    if (currentPage >= totalPages) {
      allLoaded = true;
      showNoMore();
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // 初始检查一次，防止页面本身就没撑满一屏
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ========== [NEW-CUSTOM] 无限滚动主逻辑 - 结束 ==========